<div class="accounting-document-management">
  <div class="page-header">
    <div class="page-title-block">
      <h2 class="page-title">Gestão de documentos contábeis</h2>
      <p class="page-description">
        Cobertura documental recorrente do faturamento mensal e das demonstrações financeiras.
      </p>
    </div>
    <div class="page-company-select">
      <app-select
        [options]="companyOptions()"
        [formControl]="companyControl"
        [loading]="isLoadingCompanies()"
        placeholder="Selecionar empresa..."
        label="Empresa" />
    </div>
  </div>

  @if (!companyId()) {
    <div class="empty-company-panel">
      <i class="pi pi-building"></i>
      <p>Selecione uma empresa acima para ver a cobertura documental.</p>
    </div>
  } @else if (stateService.isLoadingCoverage() && !stateService.coverage()) {
    <div class="loading-wrapper">
      <app-cog-loading-spinner />
    </div>
  } @else {
    <div class="coverage-card">
      <div class="coverage-card__header">
        <span class="coverage-card__eyebrow">{{ cardContent.eyebrow }}</span>
        <h3 class="coverage-card__title">{{ cardContent.title }}</h3>
        <p class="coverage-card__description">{{ cardContent.description }}</p>
      </div>

      <app-coverage-summary
        [years]="stateService.years()"
        [requiredWindow]="stateService.requiredWindow()"
        [isLoading]="stateService.isLoadingCoverage()"
        [viewMode]="stateService.viewMode()"
        (viewModeChange)="stateService.setViewMode($event)"
        (chipSelected)="onChipSelected($event)" />

      <ng-template #selectionSlot>
        @if (selectedPeriodCoverage()) {
          <app-period-files-panel
            [period]="selectedPeriodCoverage()!"
            [isAnnual]="selectedPeriodIsAnnual()"
            [isRevenue]="selectedPeriodIsRevenue()"
            [ruleText]="revenueRuleText()"
            (fileOpened)="openFile($event)"
            (fileRemoved)="onFileRemoved($event)" />
        }
      </ng-template>

      <app-year-coverage
        [years]="stateService.years()"
        [viewMode]="stateService.viewMode()"
        [selectedPeriod]="stateService.selectedPeriod()"
        [lastClassification]="stateService.lastClassification()"
        [uploadProgress]="stateService.classifiedUpload()"
        [canUpload]="canUploadDocuments()"
        [uploadBlockReason]="uploadBlockReason()"
        [selectionTemplate]="selectionSlot"
        (periodSelected)="stateService.selectPeriod($event)"
        (filePreviewRequested)="openFile($event)"
        (filesDroppedOnYear)="onClassifiedFilesDropped($event)"
        (onboardingRequested)="goToOnboarding()" />
    </div>
  }
</div>
